import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import pictoDownload from "../../assets/img/picto-dl.svg";

const IconDownload: FunctionComponent = () => {
  const { t } = useTranslation(["icons"]);

  return <img src={pictoDownload} alt={t("icons:DOWNLOAD_ALT")} />;
};

export default IconDownload;
